import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useTimer = () => {
  const [remainingHour, setRemainingHour] = useState(0);
  const [remainingTime, setRemainingTime] = useState("0h 0m 0s");

  const { TodayScore } = useSelector((state) => ({
    TodayScore: state.Dashboard.todayScore || {}
  }));

  const getTargetDate = () => {
    if (!TodayScore) return null;

    const now = new Date();
    const startDate = new Date();
    const endDate = new Date();

    startDate.setDate(startDate.getDate() - TodayScore.StartDay);
    endDate.setDate(endDate.getDate() + TodayScore.EndDay);

    const startTime = new Date(`${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')} ${TodayScore?.StartTime}`);
    const endTime = new Date(`${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')} ${TodayScore?.EndTime}`);

    if (startTime > now) {
      return startTime;
    }

    if (now > endTime) {
      endTime.setDate(endTime.getDate() + 1);
    }

    return endTime;
  };

  useEffect(() => {
    const updateTimer = () => {
      const now = new Date();
      const target = getTargetDate();
      if (!target) {
        setRemainingHour(0);
        setRemainingTime("0h 0m 0s");
        return;
      }

      const diffMs = target.getTime() - now.getTime();

      if (diffMs <= 0) {
        setRemainingTime("0h 0m 0s");
        return;
      }

      const totalSeconds = Math.floor(diffMs / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      setRemainingHour(hours);
      setRemainingTime(`${hours}h ${minutes}m ${seconds}s`);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [TodayScore]);

//   return remainingTime;

  return {
    remainingTime,
    remainingHour
  } 
};

export default useTimer;
